import Typography from "../Typography/Typography";
import styled from "styled-components";
import { IThemeProps } from "../../theme";
import { IHyperLinkProps } from "./hyperLink";
import withVisuallyHidden from "utils/withVisuallyHidden";

const StyledHyperLinkComponent = styled(Typography)<
  IHyperLinkProps & IThemeProps
>`
  ${({ theme, showArrow, hasAnimation, disabled, align }) => `
    font-size: ${theme.uptimeDynamicFontSize.hyperLink};
    line-height: ${theme.uptimeLineHeights.desktop.lh6}px;
    text-decoration: none;
    font-weight: 600;
    user-select: none;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    position: relative;
    width: fit-content;
    ${
      align === "left"
        ? `margin-right: unset;`
        : align === "center"
        ? `margin: 0 auto;`
        : `margin-left: auto;`
    }
    &::after {
      ${
        showArrow &&
        `
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        content: "";        
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1.3rem' height='1.3rem' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' viewBox='0 0 5 6'%3E%3Cpath d='M2.85408 3L0 0V1.125L1.78112 3L0 4.875V6L2.85408 3Z' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' fill-opacity='0.56'/%3E%3Cpath d='M5 3L2.14592 0V1.125L3.92704 3L2.14592 4.875V6L5 3Z' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' fill-opacity='0.56'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: 50%;
        background-size: 14px;
        width: 14px;
        height: 14px;
        position: absolute;
        right: 6px;
        margin-top: ${!!theme.uptimeFonts.primary ? (theme.uptimeDynamicAlignCenter?.viewMoreArrow?.marginTop ?? '-11px') : '-11px'};
        top: 17px;
        z-index: 0;
      `}
    }
    ${
      !disabled
        ? `
      cursor: pointer;
      color: ${theme.uptimeColors.generalColors.button.hyperlink.enabled};
      &:hover {
        color: ${theme.uptimeColors.generalColors.button.hyperlink.hover};
        text-decoration: underline !important;
        &::after {
          ${
            showArrow &&
            `background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1.3rem' height='1.3rem' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' viewBox='0 0 5 6'%3E%3Cpath d='M2.85408 3L0 0V1.125L1.78112 3L0 4.875V6L2.85408 3Z' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' fill-opacity='0.56'/%3E%3Cpath d='M5 3L2.14592 0V1.125L3.92704 3L2.14592 4.875V6L5 3Z' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' fill-opacity='0.56'/%3E%3C/svg%3E");`
          }
          ${
            hasAnimation &&
            `
            -webkit-transform: translateX(0.5rem);
            transform: translateX(0.5rem);
          `
          }
        }
      }
      ${showArrow && align === 'right' && `padding-right: ${theme.uptimeSpace[12]}px;`}
    ` : `
      color: ${theme.uptimeColors.grayScales.gray} !important;
      user-select: none;
      &::after {
        ${
          showArrow &&
          `
          background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1.3rem' height='1.3rem' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' viewBox='0 0 5 6'%3E%3Cpath d='M2.85408 3L0 0V1.125L1.78112 3L0 4.875V6L2.85408 3Z' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' fill-opacity='0.56'/%3E%3Cpath d='M5 3L2.14592 0V1.125L3.92704 3L2.14592 4.875V6L5 3Z' fill='${encodeURIComponent(theme.uptimeColors.generalColors.button.hyperlink.enabled)}' fill-opacity='0.56'/%3E%3C/svg%3E");
        `
        }
      }
    `
    }
  `}
`;

export const StyledHyperLink = withVisuallyHidden(StyledHyperLinkComponent);